import React from 'react';

// Utils
import { BASE_IMAGE_URI, formatCastMember } from '../../utils/helpers';

// Components
import { Heading } from '../a11y';

// Models
import { ICrewMember } from '../../utils/models';

import './CastBanner.scss';

export interface ICastBanner {
  castMember: Partial<ICrewMember>;
}

const CastBanner = ({ castMember }: ICastBanner) => {
  const { name } = castMember;
  const { personId } = formatCastMember(castMember);
  return (
    <div className="cast-banner__wrapper">
      <div className="cast-banner">
        <div className="cast-card-hero">
          <img
            src={`${BASE_IMAGE_URI}/imageserver/person/${personId}?width=191&default=true`}
            alt=""
            role="presentation"
            className="cast-card__image"
            width="191"
            height="284"
            loading="lazy"
          />
        </div>
        <Heading className="cast-card-hero__title">{name}</Heading>
      </div>
    </div>
  );
};

export default CastBanner;
